// extracted by mini-css-extract-plugin
export default {"container":"hP-z","error":"iP-z","disabled":"jP-z","submit":"kP-z","option":"lP-z","success":"mP-z","failure":"nP-z"};